import http from "lib/http/httpClient";

export type Period = | "today" | "last7days" | "last30days" | "thisMonth" | "lastMonth" | "ytd";
export type StatVariant = "total" | "positive" | "negative" | "neutral";
export interface LiveStat {
    id: string;
    title: string;
    value: number;
    variant: StatVariant;
    icon: "truck" | "check" | "clock" | "target";
}

export interface ShipmentStats {
  total_shipments: number;
  delivered: number;
  in_transit: number;
}

export interface ShipmentSeriesPoint {
  0: string;
  1: number;
}

export interface ShipmentSeriesItem {
  id: string;
  label: string;
  points: ShipmentSeriesPoint[];
}

export interface ShipmentSeriesResponse {
  series: ShipmentSeriesItem[];
}

export const getShipmentStats = async (from: string, to: string): Promise<ShipmentStats> => {
  try {
    const params = new URLSearchParams({ from, to });
    return http.get<ShipmentStats>(`/api/v1/cp/stats?${params.toString()}`);
  } catch (error) {
    console.error("Error fetching shipment stats:", error);
    throw error;
  }
};

export const getShipmentSeries = async (from: string, to: string): Promise<ShipmentSeriesResponse> => {
  try {
    const params = new URLSearchParams({ from, to });
    return http.get<ShipmentSeriesResponse>(`/api/v1/cp/stats/series?${params.toString()}`);
  } catch (error) {
    console.error("Error fetching shipment series:", error);
    throw error;
  }
};
